export { default as parseAwsResponseError } from './parseAwsResponseError';
